/**
 * Converts a string to camelCase
 * @param str - The string to convert
 * @returns The camelCase version of the string
 * @example
 * camelCase('hello-world') // 'helloWorld'
 * camelCase('hello_world') // 'helloWorld'
 * camelCase('Hello World') // 'helloWorld'
 */
export function camelCase(str: string): string {
  if (!str) {
    return ''
  }

  return str.replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase()).replace(/^[A-Z]/, (char) => char.toLowerCase())
}

/**
 * Ensures a URL ends with a trailing slash.
 * @param url - The URL to normalize
 * @returns The normalized URL ending with '/'
 */
export function ensureTrailingSlash(url = ''): string {
  if (typeof url !== 'string' || !url.length) {
    return ''
  }

  return url.endsWith('/') ? url : `${url}/`
}
